<template lang="pug">
  #ChatroomFooter.inputArea.border-top.bg-gray-light
    .py-3.px-2
      .row.no-gutters
        .col-9.pr-1.d-flex.align-items-center.justify-content-center
          textarea-autosize.bg-gray-light-2.border-0.rounded-0.shadow-none.w-100.px-3.py-2(
            v-model="text",
            placeholder="輸入訊息",
            rows="1",
            max-rows="6",
            ref="messageComposer",
            style="max-height: 200px;"
          )
        .col-3.d-flex.align-items-center.justify-content-center.pl-1.d-flex.align-items-center.justify-content-around
          .border.border-dark.bg-gray-light.rounded-circle.p-1.d-flex.align-items-center.justify-content-center.mr-1(
            style="width: 40px;height: 40px;outline:none",
            @click="sendMsgHandler()"
          )
            a(
              href="javascript: void(0);"
            )
              b-img.rounded-circle(
                :src="iconUrl.IconSend",
                fluid,
                alt="Arrow Right"
              )
          .border.border-dark.bg-gray-light.rounded-circle.p-1.d-flex.align-items-center.justify-content-center.ml-1.toolCollapse(
            style="width: 40px;height: 40px;outline:none",
            v-b-toggle.toolCollapse
          )
            a(
              href="javascript: void(0);"
            )
              b-img.rounded-circle(
                :src="iconUrl.IconShowTool",
                fluid,
                alt="Show More Tool"
              )
    b-collapse#toolCollapse(
      v-model="toolCollapseShow"
    )
      b-card.border-0(
        bg-variant="light"
      )
        .row.text-center
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconImg",
              alt="Send Image",
              style="width: 50px;height: 50px;",
              onclick="imgUpload.click()"
            )
            small.w-100.mb-0 相片
            input.d-none(
              type="file",
              accept="image/*",
              id="imgUpload",
              @change="fileUploadHandler('image')",
              ref="imgUploadInput"
            )
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconVideo",
              alt="Send Video",
              style="width: 50px;height: 50px;",
              onclick="videoUpload.click()"
            )
            small.w-100.mb-0 影片
            input.d-none(
              type="file",
              accept="video/*",
              id="videoUpload",
              @change="fileUploadHandler('video')",
              ref="videoUploadInput"
            )
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconSticker",
              alt="Send Sticker",
              style="width: 50px;height: 50px;",
              @click="openModelHandler('sticker')"
            )
            small.w-100.mb-0 貼圖
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconTemp",
              alt="Send Temp",
              style="width: 50px;height: 50px;",
              @click="openModelHandler('temp')"
            )
            small.w-100.mb-0 訊息模板
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconReserve",
              alt="Send Reservation",
              style="width: 50px;height: 50px;",
              @click="openModelHandler('reservation')"
            )
            small.w-100.mb-0 客戶預約
          .col-3.d-flex.flex-wrap.align-items-center.justify-content-center.mb-2
            b-img(
              :src="iconUrl.IconTag",
              alt="Send Tag",
              style="width: 50px;height: 50px;",
              @click="openModelHandler('tag')"
            )
            small.w-100.mb-0 客戶標籤

</template>

<script>
import IconSendUrl from '@/assets/images/icon/icon_arrow_right.png';
import IconShowToolUrl from '@/assets/images/icon/icon_plus.png';
import IconImgUrl from '@/assets/images/icon/icon_img.png';
import IconVideoUrl from '@/assets/images/icon/icon_video.png';
import IconStickerUrl from '@/assets/images/icon/icon_sticker.png';
import IconTempUrl from '@/assets/images/icon/icon_temp.png';
import IconReserveUrl from '@/assets/images/icon/icon_reserve.png';
import IconTagUrl from '@/assets/images/icon/icon_tag.png';

export default {
    name: 'ChatroomFooter',
    props: {
      user: {
        type: Object,
        default: null
      }
    },
    data() {
        return {
            iconUrl: {
              IconSend: IconSendUrl,
              IconShowTool: IconShowToolUrl,
              IconImg: IconImgUrl,
              IconVideo: IconVideoUrl,
              IconSticker: IconStickerUrl,
              IconTemp: IconTempUrl,
              IconReserve: IconReserveUrl,
              IconTag: IconTagUrl
            },
            toolCollapseShow: false,
            text: null
        };
    },
    methods: {
      sendMsgHandler() {
        const vm = this;
        if (!vm.text || vm.text === '') return;
        vm.$emit('sendHandler', {
          type: 'text',
          text: vm.text
        });
        vm.text = '';
        this.toolCollapseShow = false;
      },
      fileUploadHandler(type) {
        const vm = this;
        let obj;
        switch (type) {
          case 'image':
            obj = vm.$refs.imgUploadInput;
            break;
          case 'video':
            obj = vm.$refs.videoUploadInput;
            break;
          default:
            break;
        }
        if (!obj) return;
        if (!obj.files[0]) return;
        const file = obj.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          // 取得路徑
          const src = e.target.result;

          // 傳送事件到父元件
          const form = new FormData();
          form.append(type, file);
          const data = {
            file: form
          };

          vm.$emit('sendHandler', {
            type,
            file: data,
            src
          });
          obj.value = null;
          vm.toolCollapseHandler();
        };
      },
      // 關閉工具彈窗
      toolCollapseHandler() {
        this.toolCollapseShow = !this.toolCollapseShow;
      },
      openModelHandler(type) {
        const vm = this;
        switch (type) {
          case 'sticker':
            vm.$EventBus.$emit('openStickerModel');
            break;
          case 'temp':
            vm.$EventBus.$emit('openTempModel');
            break;
          case 'reservation':
            vm.$swal.fire({
              title: '請稍候，\n載入中',
              allowOutsideClick: false,
              heightAuto: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });
            // // 取得預約時間列表
            // vm.$store.dispatch('sa_reservation/getReservationTimeListHandler', {
            //   store_id: vm.store_id
            // })
            //   .then(() => {

            //   });
            // 取得預約服務選項
            vm.$store.dispatch('sa_reservation/getReservationTypeListHandler')
              .then(() => {
                vm.$swal.close();
                vm.$EventBus.$emit('openReservationModel');
              });
            break;
          case 'tag':
            vm.$swal.fire({
              title: '請稍候，\n載入中',
              allowOutsideClick: false,
              willOpen: () => {
                vm.$swal.showLoading();
              }
            });

            // 取得所有標籤
            vm.$store.dispatch('sa_reservation/getTagsHandler')
              .then(() => {
                // 取得該使用者的標籤
                vm.$store.dispatch('sa_reservation/getMemberTagsHandler', `${vm.user.member_uuid || vm.user.member_line_uuid}`)
                  .then(() => {
                    vm.$swal.close();
                    vm.$EventBus.$emit('openTagModel', vm.user);
                  });
              });
            break;
          default:
            break;
        }
        vm.toolCollapseHandler();
      }
    }
};
</script>

<style lang="scss" scoped>
.toolCollapse {
  img {
    transition: all .3s;
    transform: rotate(0deg);
  }
}

.collapsed {
  transition: all .3s;
  transform: rotate(0deg);
}

.not-collapsed {
  img {
    transform: rotate(225deg);
  }
}
</style>
